import React, {useState, useEffect} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useSelector} from 'react-redux';
import './market.css';
import axios from 'axios';



const Gbar=()=>{
    const [turn, setturn] = useState(1);
    const [banbok, setbanbok] = useState();
    const furi = useSelector(state=>state.mahena);
    const navi = useNavigate();
    const nout = async ()=>{
        const kake = await axios.get('/api/logout').then(dadi=>{if(dadi.data.logend === "out"){
            window.location.replace("/");
        }}).catch(e=>console.log("logout"));
    };

    useEffect(()=>{
       const coss = document.querySelector('input[name="samo"]');
       if(window.location.pathname == '/under/search'){
        return;
       };
       coss.value = "";
       setbanbok();
  
    },[window.location.href]);

    const nao = async (e)=>{
       e.preventDefault();
        const texts = e.target.samo.value.trim();
        if(texts.length == 0 || texts == banbok){
            return;
        };
        setbanbok(texts);
        const aisidari = texts.toLowerCase().split(" ");
        const params = {sea : aisidari, jun : 1};
      
        const yameda = await axios.get('/api/engine',{params}).then(a=>{ return a.data}).catch(e=>{
            if(e.response?.data?.condition === "retry"){
                console.log("retry");
            }
        }); 
        
        navi('/under/search', {state : {yo : yameda, ya : params}});
    };

    return(
    <>
    <div className='tip'>
        <div className='twtip'>
        <div className='tip00'>
        <div className='tip11'>
            <form onSubmit={nao} className='formno'>
            <input placeholder='도전하고 자랑하자' type='text' name='samo' />
            <input type='submit' className='super' value={""}/>
            </form>
        </div>
        </div>
         
       {furi?.id ? <div class='tip2'>
        <span class='naruho hline'>
            <Link to='under/pro' class='naruha'>{furi.id}</Link>
        </span>
       <span onClick={nout} class='naruho'>
        <img src={process.env.PUBLIC_URL+'/logout.png'}/>
        <p>로그아웃</p>
        </span>
        </div> : <div class='tip2'>
            <span className='tin2n'>
                <Link to='join' class='naruha'>
                <img src={process.env.PUBLIC_URL+'/login.png'}/>
                <p>로그인</p>
                </Link>
            </span>
            <span className='tin2n'>
            <Link to='/gayip' class="naruho">
            <img src={process.env.PUBLIC_URL+'/group.png'}/>
            <p>회원가입</p>
            </Link>
        </span>
        </div>}
      
        </div> 
    </div>
    <div className='guide'>
        <div className='guid2'>
            <div className='dolpa'><Link to="/" style={{textDecoration : "none"}} onClick={()=>{setturn(1); window.history.states = {page : 1, molan : "allaround", nopi: 0}; 
        window.history.tates = null;}}><img src={process.env.PUBLIC_URL+'/sidbb.png'} className='dolpam'/></Link></div>
        <div className='navi'>
            <ul>
                <li className={turn == 1 ? 'list active' : 'list'} onClick={()=>{setturn(1); window.history.states = {page : 1, molan : "allaround", nopi: 0}; window.history.tates = null;}}>
                    <a>
                        <span className='icon'>
                        <Link to="/" style={{textDecoration : "none"}} ><img src={process.env.PUBLIC_URL+'/ddola.png'} className='sangj'/></Link>
                        </span>
                        <span className='text'>
                      
                        </span>
                    </a>
                </li>
                <li className={turn == 2 ? 'list active' : 'list'} onClick={()=>{setturn(2); window.history.states = {page : 1, molan : "allaround", nopi: 0}; window.history.tates = null;}}>
                    <a>
                        <span className='icon'> 
                    <Link to="/under/prw" className='nebud'>공모전</Link>
                        </span>
                        <span className='text'>
                          
                        </span>
                    </a>
                </li>
                <li className={turn == 3 ? 'list active' : 'list'} onClick={()=>{setturn(3); window.history.states = {page : 1, molan : "allaround", nopi: 0}; window.history.tates = null;}}>
                    <a>
                        <span className='icon'>
                        <Link to="/under/pra" className='nebud'>대외활동</Link>
                        </span>
                        <span className='text'>
                       
                        </span>
                    </a>
                </li>
                <li className={turn == 4 ? 'list active' : 'list'} onClick={()=>{setturn(4); window.history.states = {page : 1, molan : "allaround", nopi: 0}; window.history.tates = null;}}>
                    <a>
                        <span className='icon'>
                        <Link to="/under/pry" className='nebud'>교육</Link> 
                        </span>
                        <span className='text'>
                       
                        </span>
                    </a>
                </li>
                <li className={turn == 5 ? 'list active' : 'list'} onClick={()=>{setturn(5); window.history.states = {page : 1, molan : "allaround", nopi: 0}; window.history.tates = null;}}>
                    <a>
                        <span className='icon'>
                        <Link to="/targets" className='nebud'>인사이트</Link>
                        </span>
                        <span className='text'>
                       
                        </span>
                    </a>
                </li>
                <div className='indicator'></div>
            </ul>
        </div>
        <div className='adv'>
            <span><Link to="/sin" className='netud'>공모전등록</Link></span>
            <span><Link to="/son" className='netud'>광고안내</Link></span>
        </div>
        </div>
    </div>
  
    </>
    );
}

export default Gbar;